import { Box, Button, Grid, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import { SlideAnimationContext } from "contexts/SlideAnimation";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

const styles = {
  title: { mb: 3, maxWidth: 500, textAlign: "center" },
  mainIcon: { pr: 2, color: "secondary.dark" },
  container: { maxWidth: 650, mb: 2 },
  text: { fontSize: 15 },
  bullet: { listStyleType: "none" },
  verifiedIcon: { pr: 1, color: green[500] },
  pitchIcon: { pr: 1, color: "info.main" },
  followUpIcon: { pr: 1, color: green[700] },
  trackIcon: { pr: 1, color: "primary.main" },
};

const WelcomePage = ({ onboardingForm }: { onboardingForm: Map }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const slideContext = useContext(SlideAnimationContext);

  const handleNext = async () => {
    if (slideContext) {
      await slideContext.slideOutUp();
      slideContext.slideInUp();
    }

    navigate(`/${routes.aboutOnboardingDemo}${location.search}`);
  };

  return (
    <>
      <Box display="flex" justifyContent="center">
        <Typography variant="h4" gutterBottom sx={styles.title}>
          <Box
            component="i"
            sx={styles.mainIcon}
            className="fa-solid fa-hand-wave"
          />
          Welcome to Bento... ready to land some brand deals?
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center">
        <Box sx={styles.container}>
          <Typography sx={styles.text}>With Bento, you get:</Typography>
          <ul>
            <li style={styles.bullet}>
              <Typography sx={styles.text}>
                <Box
                  component="i"
                  sx={styles.verifiedIcon}
                  className="fa-solid fa-sparkles"
                />{" "}
                Access to 100K+ brands
              </Typography>
            </li>
            <li style={styles.bullet}>
              <Typography sx={styles.text}>
                <Box
                  component="i"
                  sx={styles.pitchIcon}
                  className="fa-solid fa-wand-magic-sparkles"
                />{" "}
                Personalized pitches crafted for each brand
              </Typography>
            </li>
            <li style={styles.bullet}>
              <Typography sx={styles.text}>
                <Box
                  component="i"
                  sx={styles.followUpIcon}
                  className="fa-solid fa-file-pen"
                />{" "}
                Smart follow-ups and check-ins handled for you
              </Typography>
            </li>
          </ul>
          <Typography sx={styles.text}>
            Ready to land more brand deals?
          </Typography>
        </Box>
      </Box>
      <Grid container justifyContent="center" sx={{ mt: 2 }}>
        <Grid item xs="auto">
          <Button disableElevation variant="contained" onClick={handleNext}>
            Let's Get Started
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default WelcomePage;
